import {
  reqApiUrl,
  linkDict,
  activityKey,
  androidPackageUrl,
  androidAppStoreLink,
  iosAppStoreLink,
  appScheme,
  appPackageName,
  wxAppId
} from '@/config/env.js'

export default {
  version: 1.0,
  timeout: 30000,
  requestRetry: 4,
  requestRetryDelay: 800,
  tokenKey: 'accessToken',
  userInfoKey: 'userInfo',
  corporation: '盈宝信息科技（广州）有限公司',
  siteName: '盈宝登录页',
  designSize: 375,
  apiUrl: reqApiUrl,
  apiPrefix: '',
  linkDict: linkDict,
  activityKey: activityKey,
  androidPackageUrl,
  androidAppStoreLink,
  iosAppStoreLink,
  appScheme,
  appPackageName,
  wxAppId
}
